import React from "react";
import List from "@mui/material/List";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";
import NewsListDataManager from "./NewsListDataManager";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {store} from "../../../redux/store";
import { sortByChanged, sortDirectionChanged } from "./newsListSlice";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import SortBy from "../../../components/list/sort/SortBy";
import SortDirection from "../../../components/list/sort/SortDirection";

export default function NewsListSortConfig () {
    const requestParams = useSelector((state) => state.newsList.requestParams)
    const loadData = useDebouncedCallback(() => {
        NewsListDataManager.load()
    }, 1000)

    if (!requestParams) {
        return <></>
    }

    return (
        <>
            <List>
                <SortBy>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('created-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'created-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-created-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-created-date" primary="Daty utworzenia"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('publication-from-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'publication-from-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-publication-from-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-publication-from-date" primary="Daty publikacji (od)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('publication-thru-date'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'publication-thru-date'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-publication-thru-date'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-publication-thru-date" primary="Daty publikacji (do)"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('title'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'title'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-title'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-title" primary="Tytułu"/>
                        </ListItemButton>
                    </ListItem>
                </SortBy>

                <SortDirection>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('asc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'asc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-asc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-asc" primary="Rosnąco"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('desc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'desc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-desc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-desc" primary="Malejąco"/>
                        </ListItemButton>
                    </ListItem>
                </SortDirection>
            </List>
        </>
    )
}